import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

const MenuProps = {
  PaperProps: {
    style: {
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxHeight: "75vh",
      width: 500,
    },
  },
  getContentAnchorEl: null,
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
    maxWidth: 300,
  },
}));

//DATA will have an id value and a name value.  Return id
//DATA looks like: [{"1": "Music"}]
const MultipleDropDown = ({ data, placeholder, setValue, value }) => {
  const classes = useStyles();

  const handleChange = (event, child) => {
    // console.log("🚀 ~ file: MultipleDropDown.jsx:36 ~ handleChange ~ child:", child)
    // console.log(value)

    if (value.find((v) => v.id === child.props.value.id)) {
      // child (clicked item) was found in the array of things already selected
      if (value.length > 1) setValue(value.filter((item) => item.id !== child.props.value.id));
      else setValue([]);
    } else {
      // child was NOT found in the array of things already selected
      setValue([...value, child.props.value]);
    }
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="demo-mutiple-checkbox-label">{placeholder}</InputLabel>
      <Select
        style={{ minWidth: "120" }}
        labelId="demo-mutiple-checkbox-label"
        id="demo-mutiple-checkbox"
        multiple
        value={[...value]}
        name="hello"
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) => {
          // return null;
          // console.log(selected)
          var displayNames = [];
          for (var i in selected) {
            if (i !== selected.length - 1) {
              displayNames.push(selected[i].name + ", ");
            } else {
              displayNames.push(selected[i].name);
            }
          }
          return displayNames;
        }}
        MenuProps={MenuProps}
      >
        {data.map((field, index) => (
          <MenuItem
            key={index}
            value={field}
            item_id={field.id}
            // onClick={(field) => handleMenuItemChange(field, field)}
          >
            <Checkbox checked={value.find((v) => v.id === field.id) ? true : false} />
            <ListItemText primary={field.name} alt={field} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleDropDown;
